export class DtoEmpresa {
    Codigo: string = '';
    RazonSocial: string = '';
}